<template>
  <div class="app-main-content shared-charge">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          :is-append-query="false"
          :show-more-scheme="true"
          :show-simple="true"
          :expand-adv="true"
          :search-item-code="$t('CargoMsg.Cargo_SharedChargeRecord')"
          config-module="513"
          :auto-init="true"
          :custom-search-items="customSearchItems"
          :custom-sim-query-placeholder="$t('SystemMonitor.QuickSearchBusinessCode')"
          @advSearchItemCallBack="fetchData"
          @simSearchItemCallBack="fetchDataBykeyWord"
        >
          <template slot="operations">
            <el-button type="primary" @click="expandBtnClickHandler">{{ expandAllBtnLabel }}</el-button>
          </template>
          <template slot="searchAreaHeader">
            <div class="app-main-inner-row extension-conditions-form">
              <el-form :inline="true" label-position="left">
                <el-form-item :label="$t('WriteOff.revenueAndExpenditureMethod')" class="el-form-item-search">
                  <el-radio-group v-model="searchConditions.isAr">
                    <el-radio :label="-1">{{ $t('WriteOff.all') }}</el-radio>
                    <el-radio :label="1">{{ $t('WriteOff.receivables') }}</el-radio>
                    <el-radio :label="0">{{ $t('WriteOff.payables') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('WriteOff.feeType')" class="el-form-item-search">
                  <el-radio-group v-model="searchConditions.isOversea">
                    <el-radio :label="-1">{{ $t('WriteOff.all') }}</el-radio>
                    <el-radio :label="0">{{ $t('WriteOff.domestic') }}</el-radio>
                    <el-radio :label="1">{{ $t('WriteOff.international') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('Invoice.invoice_businessDate')" class="el-form-item-search">
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label-width="0">
                        <el-date-picker
                          v-model="searchConditions.inputDateStart"
                          type="date"
                          :clearable="false"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          :editable="false"
                        /></el-form-item>
                    </el-col>
                    <el-col :span="2"><span>{{ $t('Invoice.invoice_dateTo') }}</span></el-col>
                    <el-col :span="8">
                      <el-form-item label-width="0">
                        <el-date-picker
                          v-model="searchConditions.inputDateEnd"
                          type="date"
                          clearable
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label-width="0">
                        <el-checkbox v-model="allowTwoYearOutside">{{ $t('Invoice.invoice_queryLotsOfData') }}</el-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid
            config-module="191201"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :check-main-record="false"
            :deselect-main-record="false"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <!-- <div id="footer-wrapper" class="pagination-wrapper">
          <cargo-pagination
            config-module="191201"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchDataByPage"
          />
        </div> -->
      </div>
    </div>
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { formatNumberToThousands } from '@/utils'
import { querySharedCharge } from '@/api/clearing/charge'
import moment from 'moment'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

export default {
  name: 'SharedChargeRecord',
  components: { searchItem, cargoTemplateSelectorDialog },
  data() {
    return {
      loading: false,
      gridOptions: {
        suppressDoubleClickExpand: true,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              return true
            },
            innerRenderer: params => {
              const methodPath = this.documentManage.getPath('toSearchTemplate')
              const toLookMethod = this.documentManage.getPath('toLook')
              return `<a href="javascript:void(0)" style="color:#0000FF;" onclick="${toLookMethod}(event, '${params.data.jobNo}')">${params.data.jobNo}</a>
                <i class="el-icon-search" onclick="${methodPath}(event, '${params.data.jobUuid}')" style="color:#46a6ff;cursor:pointer"/>`
            }
          }
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'jobLob', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_RevenueAndExpenditureType'), field: 'receivable', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_SettlementCompany'), field: 'accountId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'oversea', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.overseaLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_Unit'), field: 'measure', width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 80,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          } },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'rate', width: 80,
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 6)
          } },
        { headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'unitRate', width: 80,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ExcludingTaxAmount'), field: 'excludingTaxAmount', width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          } },
        { headerName: this.$t('CargoMsg.Cargo_TaxRate'), field: 'taxRate', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          } },
        { headerName: this.$t('CargoMsg.Cargo_IncludedTaxAmount'), field: 'amount', width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          } },
        {
          headerName: this.$t('CargoMsg.Cargo_ShareScheme'), field: 'shareScheme', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.shareSchemeFunc(params.value)
          }
        }
      ],
      rowData: [],
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false,
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        inputDateStart: moment().subtract(2, 'y').format('yyyy-MM-DD'),
        inputDateEnd: '',
        isAr: -1, // 收付方式: 全部、应收、应付
        isOversea: -1 // 费用类型: 国内、国外
      },
      customSearchItems: [],
      btnExpandAll: false,
      documentManage: new DocumentManage(),
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOB_DETAIL',
        data: {
          JOB_UUID: []
        }
      }
    }
  },
  computed: {
    expandAllBtnLabel() {
      if (this.btnExpandAll) {
        return this.$t('queryJob.putItAllAway')
      } else {
        return this.$t('queryJob.expandAll')
      }
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        let msg = this.getConfirmMsg
        if (StrUtils.isEmpty(msg)) {
          msg = this.$t('SystemMonitor.IfTheDataLoadingYears')
        }
        this.$confirm(msg, this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(() => {
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(e, jobUuid) {
      context.toSearchTemplate(e, jobUuid)
    })
    this.documentManage.set('toLook', function(e, jobNo) {
      context.toLook(e, jobNo)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        // 业务日期
        let inputDate = ''
        if (this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00' + ',end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (!this.searchConditions.inputDateStart && this.searchConditions.inputDateEnd) {
          inputDate = 'end=' + this.searchConditions.inputDateEnd + ' 23:59:59'
        } else if (this.searchConditions.inputDateStart && !this.searchConditions.inputDateEnd) {
          inputDate = 'start=' + this.searchConditions.inputDateStart + ' 00:00:00'
        }
        if (inputDate) {
          const condition = new AdvancedSearchOption(null, 'charge.BUSINESS_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
          finallyConditions.push(condition.formatObj2Json())
        }
        if (this.searchConditions.isAr !== -1) {
          const option = new AdvancedSearchOption(null, 'charge.ACCOUNT_RECEIVABLE', this.searchConditions.isAr, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.isOversea > -1) {
          const option = new AdvancedSearchOption(null, 'charge.OVERSEA', this.searchConditions.isOversea, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      finallyConditions.push(...conditions)
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'job.JOB_NO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryList()
    },
    toQueryList() {
      const { snapshotConditions: conditions, pageNum, pageSize } = this.searchConditions
      const requestBody = { conditions, branchId: this.$store.getters.currentOfficeId, pageNum, pageSize, 'requestSource': 'SharedCharge' }
      this.loading = getLoading()
      querySharedCharge(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = res.data.total
      }).finally(() => {
        this.loading.close()
      })
    },
    expandBtnClickHandler() {
      this.btnExpandAll = !this.btnExpandAll
      if (this.btnExpandAll) {
        this.gridApi.expandAll()
      } else {
        this.gridApi.collapseAll()
      }
    },
    toSearchTemplate(e, jobUuid) {
      stopBubble(e)
      if (jobUuid) {
        this.templateSelectorDialog.data.JOB_UUID = jobUuid
        this.templateSelectorDialog.category = 'JOB_DETAIL'
        this.templateSelectorDialog.visible = true
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundTemplate'))
      }
    },
    toLook(e, jobNo) {
      stopBubble(e)
      if (!this.$checkPermission(['module_ACVerify'])) {
        this.$message.error(this.$t('Message.YouToOpenTheModule', [this.$t('CargoMsg.Cargo_FinancialAudit')]))
        return
      }
      this.$router.push({
        name: 'FinanceManage',
        query: {
          jobNo: jobNo,
          currentOfficeId: this.$store.getters.currentOfficeId
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .shared-charge {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
